<!--
@Author: Calvin Green <calvin>
@Date:   2022-03-02T11:43:30+02:00
@Email:  calvin@diversitude.com
@Last modified by:   calvin
@Last modified time: 2022-05-17T20:11:15+02:00
@Copyright: Diversitude 2022
-->



<template>
    <div>
        <b-row>
            <b-col cols="12">
                <b-card body-class="pb-1">
                    <div>
                        <span><i @click="$emit('back')" style="color: grey !important; font-size: 3rem; cursor: pointer;" class="fas fa-times text-light mb-4 me-4 pb-2"></i></span>
                        <span style=" font-size: 2rem;">
                            Distribute SOP -
                            <span v-if="has_mounted" class="underline-heading">
                                {{ sop_data.name }}
                            </span>
                        </span>
                    </div>
                </b-card>
            </b-col>
        </b-row>
        <b-row>
            <b-col cols="6" sm="8">
                <!-- <annotate-pdf
                    v-if="b64 != null && show_document"
                    :sign_mode="false"
                    :base64="b64"/> -->
                <div v-if="b64 != null && show_document">
                    <iframe :src="b64 + '#toolbar=0'" style="width: 100%; height: 80vh;"></iframe>
                </div>
                <b-alert v-else show>{{ message }}</b-alert>
            </b-col>
            <b-col cols="6" sm="4">
                <b-card title="Distribution">
                    <b-row>
                        <b-col>
                            <b-button :variant="returnStyle('uncontrolled')" :disabled="distribution_type !== 'uncontrolled'">
                                Uncontrolled
                            </b-button>
                        </b-col>
                    </b-row>
                    <hr>
                    <b-row>
                        <b-col cols="12">
                            <b-form class="">
                                <b-row>
                                    <b-col cols="6">
                                        <b-form-group id="name" label="Copy Holder Name" label-for="name-input">
                                            <b-form-input id="name-input" v-model="form.name" placeholder="Name of copy holder" required></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                    <b-col cols="6">
                                        <b-form-group id="email" label="Copy Holder Email" label-for="email-input">
                                            <b-form-input id="email-input" v-model="form.email" type="email" placeholder="Copy holder email" required></b-form-input>
                                        </b-form-group>
                                    </b-col>
                                    <b-col class="mt-3" cols="12">
                                        <b-form-group id="reason" label="Reason" label-for="reason-input">
                                            <b-form-textarea id="reason-input" v-model="form.reason_text" rows="4" no-resize placeholder="Reason for copy request"></b-form-textarea>
                                        </b-form-group>
                                    </b-col>

                                    <b-col cols="12">
                                        <b-button :disabled="disableButton" @click="saveData" size="lg" variant="success">
                                            SEND
                                        </b-button>
                                    </b-col>
                                </b-row>
                            </b-form>
                        </b-col>
                    </b-row>
                </b-card>
            </b-col>
        </b-row>
        <b-overlay :show="is_loading" no-wrap></b-overlay>
    </div>
</template>

<script>
import Swal from 'sweetalert2'
//eslint-disable-next-line
import _ from 'lodash'
import { sopClientAdminMethods, sopClientAdminState, layoutMethods } from "@/state/helpers"
export default {
    props:{
        sop_id:{}
    },
    data:() => ({
        sop_details: null,
        revision_id: null,
        has_mounted: false,
        is_loading: false,
        show_document: false,
        b64: null,
        distribution_type: 'uncontrolled',
        message: 'Waiting for document data',
        form:{
            name: '',
            reason_text: '',
            email: '',
        }
    }),
    computed:{
        ...sopClientAdminState,
        disableButton(){
            if(this.form.reason_text === '' || this.form.email === '' || this.form.name === '' || this.b64 == null){
                return true;
            }
            else{
                return false;
            }
        }
    },
    methods:{
        ...layoutMethods,
        ...sopClientAdminMethods,
        returnStyle(type){
            if(type === 'distribution_type'){
                return 'success'
            }
            else{
                return 'light'
            }
        },
        saveData(){
            let params = {
                client_revision_id: this.revision_id,
                copy_holder_name: this.form.name,
                copy_holder_email: this.form.email,
                reason_for_copy: this.form.reason_text,
            }
            //console.log(params);
            this.is_loading = true;
            this.distributeSOP(params)
            .then(()=>{
                Swal.fire({ toast: true, position: 'top', iconColor: 'white', icon: 'success', title:'SOP Distributed', customClass: {     popup: 'success-toast' }, showConfirmButton: false, timer: 2000, timerProgressBar: true});
                this.form = {
                    name: '',
                    reason_text: '',
                    email: ''
                };
                this.is_loading = false;
            })
            .catch(()=>{
                this.is_loading = false;
            })
        },
        loadB64(revision_id){
            this.b64 = null;
            window.axios({
                url: 'api/clientdocadmin/b64preview/' + revision_id,
                method: 'GET',
                responseType: 'blob',
            })
            .then((response) => {
                this.b64 = window.URL.createObjectURL(response.data);
                this.show_document = true;
            }).catch(() => {
                this.show_document = false;
            });
            /*this.getPreviewB64(revision_id)
            .then( data => {
                if(data.pdf_64 != undefined){
                    this.b64 = data.pdf_64;
                    this.show_document = true;
                    //let element = document.getElementById('pdfScrollBar');
                    //element.addEventListener('scroll', this.handleScrollEvent)
                }
            })*/
        },
        showDistMenu(){
            this.hideMenu = false;
            this.updateMenuType({
                type: 'client_admin_distribution',
                showMenu: false,
                showRoutes: false,
            })
        },
        findPublishedSop(){
            let index = _.findIndex(this.sop_data.client_revisions, { published: 1})
            if(index > -1){
                this.sop_details = this.sop_data;
                this.revision_id = this.sop_data.client_revisions[index].client_revision_id
                this.loadB64(this.revision_id);
                //this.has_mounted = true;
            } else {

                this.message = "There is not currently a published SOP revision!";
            }
        }
    },
    mounted(){
        this.is_loading = true;
        this.showDistMenu();
        this.loadSopData(this.sop_id)
        .then(()=>{
            this.is_loading = false;
            this.has_mounted = true;
            this.findPublishedSop();
        })
        //this.loadB64();
    },
}
</script>

<style>

</style>
